<template>
  <el-dialog title="选择商品"
             :visible.sync="visible"
             width="1060px"
             @closed='handleClose'
             :close-on-press-escape="false">
    <el-row :gutter="12">
      <el-col :span="12">
        <div style="text-align: left;margin-bottom: 10px;color:#000;line-height: 32px;font-size:18px">
          已选择：
        </div>
        <el-table border
                  v-loading="loading"
                  height="480px"
                  :data="multipleSelection">
          <el-table-column label="商品名称"
                           min-width="160"
                           prop="productName">
            <template slot-scope="{row}">
              {{row.productName}}
            </template>
          </el-table-column>
          <el-table-column label="商品备注"
                           min-width="100">
            <template slot-scope="{row}">
              <span v-if="row.productNameRemark">({{row.productNameRemark}})</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="60">
            <template slot-scope="{ row, $index }">
              <el-button type="text"
                         @click="deleteItem(row, $index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="12">
        <div style="display: flex;align-items: center;justify-content: space-between;;margin-bottom: 10px;">
          <span style="color:#000;line-height: 32px;font-size:18px">请选择：</span>
          <div>
            <el-input placeholder="请输入商品备注"
                      v-model="config.productNameRemark"
                      clearable=""
                      style="width: 150px;margin-right:10px">
            </el-input>
            <el-input placeholder="请输入商品名称"
                      v-model="config.productName"
                      clearable=""
                      style="width: 200px;">
              <el-button slot="append"
                         icon="el-icon-search"
                         @click="handleCurrentChange(1)"></el-button>
            </el-input>
          </div>
        </div>
        <el-table border
                  ref="table"
                  v-loading="loading"
                  height="480px"
                  :data="list">
          <el-table-column label="商品名称"
                           min-width="160"
                           prop="productName">
            <template slot-scope="{row}">
              {{row.productName}}
            </template>
          </el-table-column>
          <el-table-column label="商品备注"
                           min-width="100">
            <template slot-scope="{row}">
              <span v-if="row.productNameRemark">({{row.productNameRemark}})</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="60">
            <template slot-scope="{ row, $index }">
              <el-button type="text"
                         :disabled="row.isAdded"
                         @click="addItem(row, $index)">{{ row.isAdded ? '已添加' : '添加' }}</el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column label="监管类别">
        <template slot-scope="{row}">
          <el-tag v-if="row.legalTest === 0">非法检</el-tag>
          <el-tag type="danger"
            v-if="row.legalTest === 1">法检</el-tag>
        </template>
      </el-table-column> -->
          <!-- <el-table-column label="创建时间"
                       width="100">
        <template slot-scope="{row}">
          {{ row.createdTime | dateformat('YYYY-MM-DD')}}
        </template>
      </el-table-column> -->
        </el-table>
        <el-pagination background style="text-align:center"
                       @current-change="handleCurrentChange"
                       :current-page.sync="config.pageNum"
                       :page-size="config.pageSize"
                       layout="total, prev, pager, next"
                       :total="total">
        </el-pagination>
      </el-col>
    </el-row>
    <span slot="footer">
      <el-button @click="toggleModal(false)"
                 :loading="loading">取消</el-button>
      <el-button type="primary"
                 @click="submit"
                 :loading="loading">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'associate-product-modal',
  components: {},
  props: {
    isSubOrder: { type: Boolean, default: false },
    selected: {
      type: Array,
      default () {
        return []
      }
    },
    option: {
      type: Object,
      default () {
        return { vendorId: '', tradeType: '' }
      }
    }
  },
  data () {
    return {
      inited: true,
      loading: false,
      visible: false,
      config: { pageNum: 1, pageSize: 10, productName: '', productNameRemark: '' },
      list: [],
      total: 0,
      multipleSelection: []
    }
  },
  // watch: {
  //   visible (val, oldVal) {
  //     if (val) {
  //       if (this.inited) {
  //         this.inited = false
  //         this.$nextTick(() => {
  //           this.selected.forEach(item => {
  //             this.$refs.table.toggleRowSelection(item, true)
  //           })
  //           this.fetchList()
  //         })
  //       }
  //     }
  //   }
  // },
  methods: {
    deleteItem (row, $index) {
      this.multipleSelection.splice($index, 1)
      this.countList(this.list)
      console.log(row, $index)
    },
    addItem (row, $index) {
      this.multipleSelection.push(JSON.parse(JSON.stringify(row)))
      this.countList(this.list)
      console.log(row, $index)
    },
    fetch () {
      this.$set(this, 'multipleSelection', JSON.parse(JSON.stringify(this.selected)))
      this.visible = true
      this.fetchList()
    },
    toggleModal (visible) {
      this.visible = visible
    },
    handleClose () {
      this.config.pageNum = 1
    },
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList () {
      this.loading = true
      const dispatch = this.isSubOrder ? 'inspect/getcaninspectionproducts' : 'product/getproducts'
      this.$store.dispatch(dispatch, {
        payload: { ...this.config, ...this.option },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.countList(res.data.records)
          // this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    countList (list) {
      this.list = list.map(i => {
        return {
          ...i,
          isAdded: this.multipleSelection.findIndex(s => s.productId === i.productId) > -1
        }
      })
    },
    submit () {
      this.$emit('update:selection', this.multipleSelection)
      this.toggleModal(false)
    },
    handleSelectionChange (val) {
      this.multipleSelection = val // 勾选放在multipleSelection数组中
    }
  }
}
</script>
<style lang="stylus" scoped></style>
